/* ============================================================
   MCC HEADER — mcc-header.js
   Upload to: Assets folder in Shopify Dawn theme
   ============================================================ */

(function () {
  'use strict';

  /* ── Cached Elements ── */
  const header        = document.getElementById('mcc-header');
  const mobileToggle  = document.getElementById('mcc-mobile-toggle');
  const mobileClose   = document.getElementById('mcc-mobile-close');
  const mobileNav     = document.getElementById('mcc-mobile-nav');
  const mobileOverlay = document.getElementById('mcc-mobile-overlay');
  const announce      = document.getElementById('mcc-announce');
  const cartCount     = document.getElementById('mcc-cart-count');

  /* ── Sticky header shadow ── */
  const onScroll = () => {
    if (header) {
      header.classList.toggle('mcc-header--scrolled', window.scrollY > 10);
    }
    /* Adjust mega menu top when announce bar scrolls away */
    updateMegaTop();
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  function updateMegaTop() {
    if (!header) return;
    const announceH = (announce && announce.offsetHeight) || 0;
    const headerH   = header.offsetHeight || 64;
    const top       = announceH + headerH;
    document.querySelectorAll('.mcc-mega').forEach(m => {
      m.style.top = top + 'px';
    });
  }
  // Run once on load
  updateMegaTop();
  window.addEventListener('resize', updateMegaTop, { passive: true });

  /* ── Mobile Drawer ── */
  // MCC R1 (10/16/2026), phone menu: the drawer and its overlay are printed inside the header section, which the
  // theme makes its own stacking layer (position: sticky; z-index: 3). The top bar's section (z-index 4) and the
  // phone "Filter & Sort" bar (sticky, z-index 50) therefore painted over the open drawer, whatever its own
  // z-index (990). On the first open both move to the end of <body>, where their z-index (overlay 980, drawer 990)
  // counts against the whole page. They stay there after closing (moving them back would run the slide-out under
  // those bars again). While the drawer is open <html> carries mcc-mnav-open: the inline style in
  // snippets/mcc-header.liquid hides the Filter & Sort bar and the Smile.io rewards launcher until it closes.
  const root = document.documentElement;
  function liftDrawer() {
    if (mobileOverlay && mobileOverlay.parentNode !== document.body) document.body.appendChild(mobileOverlay);
    if (mobileNav.parentNode !== document.body) {
      document.body.appendChild(mobileNav);
      void mobileNav.offsetWidth; // slide in from the closed position in its new place
    }
  }

  function openMobile() {
    if (!mobileNav) return;
    // MCC R1 (10/16/2026): the phone filter sheet (assets/mcc-mobile-filters.js) covers the hamburger while it is
    // open, so a tap can't open both; close it anyway if something else opens the drawer meanwhile.
    if (root.classList.contains('mcc-msheet-open')) {
      const sheetClose = document.querySelector('.mcc-msheet.is-open .mcc-msheet__x');
      sheetClose && sheetClose.click();
    }
    liftDrawer(); // MCC R1 (10/16/2026)
    mobileNav.classList.add('is-open');
    mobileOverlay && mobileOverlay.classList.add('is-open');
    mobileToggle && mobileToggle.classList.add('is-open');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    root.classList.add('mcc-mnav-open'); // MCC R1 (10/16/2026)
    document.body.style.overflow = 'hidden';
  }

  function closeMobile() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileOverlay && mobileOverlay.classList.remove('is-open');
    mobileToggle && mobileToggle.classList.remove('is-open');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    root.classList.remove('mcc-mnav-open'); // MCC R1 (10/16/2026)
    document.body.style.overflow = '';
  }

  mobileToggle && mobileToggle.addEventListener('click', openMobile);
  mobileClose  && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);

  /* ── Mobile accordion sub-menus ── */
  document.querySelectorAll('.mcc-mobile-nav__parent-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub      = btn.nextElementSibling;
      const isOpen   = sub && sub.classList.contains('is-open');
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      // Close all open subs first
      document.querySelectorAll('.mcc-mobile-nav__sub.is-open').forEach(s => s.classList.remove('is-open'));
      document.querySelectorAll('.mcc-mobile-nav__parent-btn[aria-expanded="true"]').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        const span = b.querySelector('span');
        if (span) span.textContent = '+';
      });

      // Toggle clicked
      if (!isOpen) {
        sub && sub.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        const span = btn.querySelector('span');
        if (span) span.textContent = '−';
      }
    });
  });

  /* ── Escape key closes everything ── */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobile();
    }
  });

  /* ── Live cart count update ── */
  // MCC R1 (10/2026): one setter for the badge. It also sets data-count, so the hide rule
  // .mcc-cart-count[data-count="0"] (mcc-header.css) applies. cartSeq drops a /cart.js reply
  // that was requested before a newer count arrived (slow page-load fetch vs. a quick add).
  let cartSeq = 0;
  function setCartCount(count) {
    if (!cartCount || typeof count !== 'number') return;
    cartCount.textContent = count > 0 ? count : '';
    cartCount.setAttribute('data-count', count);
  }

  // Refresh cart count via Shopify AJAX API on any add-to-cart
  function refreshCartCount() {
    const seq = ++cartSeq; // MCC R1 (10/2026)
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        if (seq === cartSeq) setCartCount(data.item_count); // MCC R1 (10/2026): was an inline textContent write
      })
      .catch(() => {});
  }

  // MCC R1 (10/2026): the snippet prints "0" for an empty cart, which the CSS can't hide. Clear it now
  // rather than when /cart.js answers.
  if (cartCount && cartCount.textContent.trim() === '0') setCartCount(0);

  // Listen for Shopify cart:add events (fired by Dawn's cart drawer)
  document.addEventListener('cart:add', refreshCartCount);
  document.addEventListener('cart:update', refreshCartCount);

  // MCC R1 (10/2026): nothing in the theme fires the two DOM events above. Dawn reports every cart change
  // through pubsub: product-form.js (product page Add), cart.js (cart page quantity/remove),
  // mcc-quick-add.js (card Add). pubsub.js + constants.js are deferred in <head>, so they ran before this file.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const data = event && event.cartData;
      if (data && typeof data.item_count === 'number') {
        cartSeq++; // a full cart came with the event; any older /cart.js reply is stale
        setCartCount(data.item_count);
      } else {
        refreshCartCount(); // product-form sends the added line item, which has no item_count
      }
    });
  }

  // MCC R1 (10/2026): a back/forward-cache restore shows the old page as it was. Re-read the count
  // (e.g. items removed on /cart, then Back).
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCartCount();
  });

  // Also poll once on load for fresh count
  refreshCartCount();

  /* ── Active nav item highlight ── */
  const currentPath = window.location.pathname;
  document.querySelectorAll('.mcc-nav__link').forEach(link => {
    const href = link.getAttribute('href');
    if (href && href !== '/' && currentPath.startsWith(href)) {
      link.closest('.mcc-nav__item') && link.closest('.mcc-nav__item').classList.add('mcc-nav__item--active');
    }
  });

})();
